import ChevronLeftIcon from '@common/components/Icons/ChevronLeftIcon';
import moment from 'moment';
import React from 'react';
import {
  ActivityIndicator,
  FlatList,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import { useChatComponentContext } from '../context';
import { InputMessage } from './InputMessage';
import { MessageItem } from './MessageItem';
import { SpHeader } from './SpHeader';
import { useChatComponent } from '../hook';
import {
  INPUT_LINE_HEIGHT,
  MESSAGE_LIST_PADDING_BOTTOM,
  MESSAGE_LIST_PADDING_BOTTOM_WITH_FILES,
} from '../utils';

export const MessageHistory = ({
  showBackButton,
}: {
  showBackButton?: boolean;
}) => {
  const {
    listRef,
    filesValue,
    inputLines,
    messageHistoryLoading,
    selectedGroup,
    messageHistories,
    props,
    handleScroll,
    isOwnMessage,
  } = useChatComponentContext();
  const { onSelectGroup, fetchMessageHistoryNextPage } =
    useChatComponent(props);

  const groupName = selectedGroup?.groupName || '';
  const numberOfUsers = selectedGroup?.numberOfUsers || 100;
  return (
    <View
      style={[
        styles.container,
        {
          // The composer is position:absolute; bottom:0, so the list has to
          // reserve its footprint. Zero delta at one line, so this is
          // identical to before until the user types a second line.
          paddingBottom:
            (filesValue?.length
              ? MESSAGE_LIST_PADDING_BOTTOM_WITH_FILES
              : MESSAGE_LIST_PADDING_BOTTOM) +
            (inputLines - 1) * INPUT_LINE_HEIGHT,
        },
      ]}
      nativeID="MessageHistory"
    >
      <View style={styles.headerContainer}>
        <TouchableOpacity
          onPress={() => {
            onSelectGroup?.(null);
          }}
          style={[
            styles.backButtonContainer,
            {
              display: showBackButton ? 'flex' : 'none',
            },
          ]}
        >
          <ChevronLeftIcon />
        </TouchableOpacity>
        <SpHeader text={groupName} numberOfUsers={numberOfUsers} />
      </View>
      {messageHistoryLoading && (
        <View style={styles.loadingContainer}>
          <ActivityIndicator />
        </View>
      )}
      <FlatList
        ref={listRef}
        style={styles.messageHistoryContainer}
        nativeID="list-message"
        onScroll={(e) => {
          const isScrollToTop = e.nativeEvent.contentOffset.y === 0;
          if (isScrollToTop) {
            fetchMessageHistoryNextPage?.();
          }
          handleScroll?.(e);
        }}
        data={messageHistories.sort((a, b) =>
          moment(a.createdAt).diff(moment(b.createdAt))
        )}
        nestedScrollEnabled
        ListFooterComponent={() => {
          return <View style={{ height: 100 }} />;
        }}
        renderItem={({ item: message, index }) => {
          const ownMessage = isOwnMessage?.({
            senderId: message.senderId,
          });
          if (ownMessage) {
            return (
              <MessageItem.OwnMessage
                message={message}
                key={message.id}
                isLastMessage={messageHistories.length === index + 1}
              />
            );
          }
          return (
            <MessageItem.ReceivedMessage message={message} key={message.id} />
          );
        }}
      />
      <InputMessage />
    </View>
  );
};
const styles = StyleSheet.create({
  loadingContainer: {
    padding: 6,
  },
  container: {
    paddingHorizontalHorizontal: 4,
    borderRadius: 4,
    backgroundColor: '#F2F5F7',
    position: 'relative',
    height: '100%',
  },
  headerContainer: {
    position: 'relative',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 4,
  },
  backButtonContainer: {
    position: 'absolute',
    top: 0,
    left: 12,
    width: 24,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 24,
    zIndex: 1,
  },
  messageHistoryContainer: {
    paddingHorizontal: 4,
    paddingTop: 20,
    paddingBottom: 45,
    marginBottom: 4,
  },
});
